var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowButton = function SvgArrowButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    fill: "none",
    viewBox: "0 0 14 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.458 5.833H1.167a.8.8 0 0 1-.594-.24A.8.8 0 0 1 .333 5q0-.354.24-.594t.594-.24h9.291L8.083 1.793a.76.76 0 0 1-.24-.584.85.85 0 0 1 .833-.844.78.78 0 0 1 .595.24l3.812 3.813a.7.7 0 0 1 .178.27.9.9 0 0 1 .052.313.9.9 0 0 1-.053.312.7.7 0 0 1-.177.271L9.271 9.396a.78.78 0 0 1-.594.24.85.85 0 0 1-.833-.844.76.76 0 0 1 .24-.584z"
  })));
};
export default SvgArrowButton;